import { useContext } from "react";
import POSContext from "./POSContext";
import { useDispatch } from "react-redux";
import { notifyError, notifySuccess } from "redux/actions/Notifications";

function useDetailHandlers({ onDetailSuccess, setSelectedDetail }) {
    const dispatch = useDispatch();

    const { Detail } = useContext(POSContext);

    const onSuccess = (form) => {
        dispatch(notifySuccess("Payment saved successfully!"));
        form.setSubmitting(false);
        form.resetForm();
        setSelectedDetail(undefined);
    };

    const onError = (error, form) => {
        form.setSubmitting(false);
        dispatch(notifyError(error.message));
    };

    const onSaveHandler = (values, form) => {
        const { posEntryMasterId, id, amount, categoryId, paymentMethod, notes } = values;
        const apiCall = id ? Detail.update : Detail.add;
        const payload = {
            posEntryMasterId,
            id,
            amount: Number(amount),
            categoryId: Number(categoryId),
            paymentMethod,
            notes,
        };
        form.setSubmitting(true);
        apiCall({
            payload,
            onSuccess: (newId) => {
                onSuccess(form);
                onDetailSuccess(newId, payload);
            },
            onError: (error) => onError(error, form),
        });
    };

    return {
        onSaveHandler,
    };
}

export default useDetailHandlers;
